import { css } from 'lit-element';

export const utilsClasses = css`
  .w-100 {
    width: 100%;
  }

  .h-100 {
    height: 100%;
  }

  /** Screen reader only **/
  .sr-only {
    position: absolute;
    margin: -1px;
    padding: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .ellipsis-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;
